import $ from 'jquery';
import storesData from '../../data/stores-data.js';

export default class Stores {
	constructor() {
		this.$retailersButton = $('#retailersButton');
		this.$retailers = $('.stores_retailers');

		this.init();
	}

	init() {
		this.setupRetailers();
		this.setupEventListeners();
	}

	setupRetailers() {
		// 店舗リストを生成
		const $grid = $('<div>', { class: 'stores_retailers_grid' });

		storesData.retailers.stores.forEach((store) => {
			const $item = $('<div>', { class: 'stores_retailer_item' });
			const $link = $('<a>', {
				href: store.url,
				target: '_blank',
				rel: 'noopener noreferrer',
			}).html(store.name);
			$item.append($link);
			$grid.append($item);
		});

		this.$retailers.append($grid);
	}

	setupEventListeners() {
		// アコーディオンボタンのクリックイベント
		this.$retailersButton.on('click', () => {
			this.toggleRetailers();
		});
	}

	toggleRetailers() {
		const $icon = this.$retailersButton.find('.stores_button_icon--plus');

		// アイコンの回転状態を切り替え
		$icon.toggleClass('is-open');

		// アコーディオンをスライドトグル
		this.$retailers.slideToggle(500);
	}
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
	new Stores();
});
